<template>
  <DetailsContentPane
    :class="selectionStep === 1 ? 'overflow-hidden' : ''"
  >
    <CabinCategorySelector
      v-if="selectionStep === 0"
      :click-next="clickNextCategory"
    />
    <PremiumCabinSelector
      v-if="selectionStep === 1"
      :back-clicked="clickPrev"
      :proceed-clicked="clickNextCabin"
    />
  </DetailsContentPane>
</template>

<script lang="ts">
import { useDetailsStore, useUiStore } from '@/store';
import { mapActions, mapState } from 'pinia';
import { defineComponent } from 'vue';
import { COMFORTAI, IND, INDAI } from '../../../general/master-data';
import DetailsContentPane from '../DetailsContentPane.vue';
import CabinCategorySelector from './CabinCategorySelector.vue';
import PremiumCabinSelector from './PremiumCabinSelector.vue';

export default defineComponent({
  components: {
    DetailsContentPane,
    CabinCategorySelector,
    PremiumCabinSelector
  },

  data: () => {
    return {
      selectionStep: 0,
    }
  },

  computed: {
    ...mapState(useDetailsStore, {
      priceModel: store => store.priceModel,
    }),
  },

  methods: {
    ...mapActions(useUiStore, {
      setDetailsPanelActiveTab: 'setDetailsPanelActiveTab'
    }),

    clickNextCategory() {
      if ([COMFORTAI, INDAI, IND].includes(this.priceModel!)) {
        this.selectionStep = 1
      } else {
        this.setDetailsPanelActiveTab('transportation')
      }
    },
    clickPrev() {
      this.selectionStep = 0
    },
    clickNextCabin() {
      this.setDetailsPanelActiveTab('transportation')
    },
  },
})
</script>
